const scrollToTop = () => {
    if ($('.js-scroll-to-top').length) {
        $(window).scroll(function() {
            let scroll = $(window).scrollTop();

            if (scroll >= 500) {
                $('.js-scroll-to-top').addClass("active");
            } else {
                $('.js-scroll-to-top').removeClass("active");
            }
        });
        
        let rootElement = document.documentElement;
        
        $('.js-scroll-to-top').on('click', function(e) {
            e.preventDefault();
            rootElement.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        })
    }
}